// Мелкие общие элементы. Ничего умного: их задача — держать одинаковыми
// плитку, бирку источника и кнопку копирования на всех шести страницах.

import { useState, type ReactNode } from 'react';

export function Tile({
  label,
  value,
  unit,
  note,
  tone = 'plain',
}: {
  label: string;
  value: ReactNode;
  unit?: string;
  note?: ReactNode;
  tone?: 'plain' | 'good' | 'warn' | 'bad';
}) {
  return (
    <div className={`tile ${tone}`}>
      <div className="label">{label}</div>
      <div className="value">
        {value}
        {unit && <small>{unit}</small>}
      </div>
      {note && <div className="note">{note}</div>}
    </div>
  );
}

export function Panel({
  title,
  aside,
  children,
  flush = false,
}: {
  title: string;
  aside?: ReactNode;
  children: ReactNode;
  flush?: boolean;
}) {
  return (
    <section className="panel">
      <header>
        <h2>{title}</h2>
        {aside}
      </header>
      <div className={flush ? 'body flush' : 'body'}>{children}</div>
    </section>
  );
}

/** Бирка источника. Показывается везде, где данные могли прийти из образца. */
export function OriginTag({ origin }: { origin: 'server' | 'sample' }) {
  return origin === 'server' ? (
    <span className="tag good">сервер</span>
  ) : (
    <span className="tag warn">образец</span>
  );
}

export function Callout({
  title,
  tone = 'warn',
  children,
}: {
  title?: string;
  tone?: 'warn' | 'hard' | 'info';
  children: ReactNode;
}) {
  return (
    <div className={`callout ${tone === 'warn' ? '' : tone}`}>
      {title && <h3>{title}</h3>}
      {children}
    </div>
  );
}

export function CopyButton({ text, label = 'копировать' }: { text: string; label?: string }) {
  const [done, setDone] = useState(false);
  return (
    <button
      className="ghost"
      onClick={() => {
        void navigator.clipboard
          .writeText(text)
          .then(() => {
            setDone(true);
            window.setTimeout(() => setDone(false), 1400);
          })
          .catch(() => setDone(false));
      }}
      title={text}
    >
      {done ? 'скопировано' : label}
    </button>
  );
}
